$(document).ready(function () {
	if ($('#footer').length) {
		// Instagram widget — přeskládání nativního .instagram-widget do .myig gridu před #footer
		if ($(".instagram-widget").length > 0 && $(".myig").length === 0) {
			$("<div class='myig'><div class='myig-posts'></div></div>").insertBefore("#footer");

			$(".instagram-widget > a")
				.filter(function () {
					return /^https:\/\/www\.instagram\.com\/p\/[^/]+\/?$/.test(this.href);
				})
				.slice(0, 6)
				.appendTo(".myig-posts");
		}

		if ($(window).width() <= 767) {
			$('.custom-footer > div').each(function () {
				var $part = $(this).find('.myfooter-part');
				var $h4 = $part.children('h3');
				if ($h4.length) {
					$part.addClass('can-toggle').children().not('h3').hide();
					$h4.on('click', function () {
						$(this).siblings().stop(true, true).slideToggle();
						$(this).closest('.can-toggle').toggleClass('active');
					});
				}
			});

			// custom-footer__articles je Shoptet pageElement bez .myfooter-part —
			// toggle navěsíme přímo na jeho .pageElement__heading nadpis
			var $articles = $('.custom-footer__articles');
			var $articlesHeading = $articles.children('.pageElement__heading');
			if ($articlesHeading.length) {
				$articles.addClass('can-toggle').children().not('.pageElement__heading').hide();
				$articlesHeading.on('click', function () {
					$(this).siblings().stop(true, true).slideToggle();
					$(this).closest('.can-toggle').toggleClass('active');
				});
			}
		}
	}
});
